import {Stack} from "@mui/material";
import {ErrorOutline} from "@mui/icons-material";

interface IFailedGalleryCardProps {
    onClick?: () => void
}

export const FailedGalleryCard = ({onClick}: IFailedGalleryCardProps) => {
    return (
        <Stack onClick={onClick} width={'100%'} sx={{aspectRatio: '1/1', backgroundColor: '#000000', borderRadius: '4px', width: '100%', cursor: 'pointer'}} alignItems={'center'} justifyContent={'center'} spacing={1}>
            <ErrorOutline sx={{color: '#ff6b6b', fontSize: '40px'}} />
        </Stack>
    )
};
